import React, { useContext } from 'react'
import { PageContext } from '../../context/PageContect';
import Application from '../Application/Application';
// import Dashboard from '../Dashboard/Dashboard';
import "./MainWindow.css";
import SelectChurch from '../SelectChurch/SelectChurch';

function MainWindow(props) {

  const { dataLoaded } = useContext(PageContext);

  React.useEffect(() => {
    const churchId = props.churchid;
    if (churchId) {
      window.location.href = `https://tworings.in/register/${churchId}`;
    } else {
      window.location.href = 'https://tworings.in/register/';
    }
  }, [props.churchid]);

  return null;
}

export default MainWindow